import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { INotification } from 'src/app/common/model/notification.model';
import { NotificationsService } from 'src/app/common/services/notifications/notifications.service';

@Component({
  selector: 'app-side-notifications',
  templateUrl: './side-notifications.component.html',
  styleUrls: ['./side-notifications.component.scss']
})
export class SideNotificationsComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  notifications: INotification[] = [];
  allNotifications: INotification[] = [];

  constructor(private notificationService: NotificationsService) {}

  ngOnInit(): void {
    this.getAllNotifications();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getAllNotifications(): void {
    this.subscriptions.add(
      this.notificationService.getLatestNotifications().subscribe({
        next: (res) => {
          this.notifications = res.result;
        }
      })
    );
  }
}
